'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useCallback, useEffect } from 'react';
import { CTAWrapper, AIReviewCVWrapper, AIReviewCVContainer, LeftSection, RightSection, CVSelectWrapper, ResumeList } from './AIReviewCV.css.js';
import Popup from '../Popup/index.js';
import { ELanguage } from '../Utils/constants.js';
import { colors } from '../Colors/index.js';
import { translations } from './translations.js';
import Typography from '../Typography/index.js';
import DragDropResumeUpload from '../DragDropResumeUpload/index.js';
import ResumeItem from './ResumeItem/ResumeItem.js';
import { getResume, getProfileLevel } from '../ApplyJobs/services/your-resume.js';
import { getDefaultResume } from '../ApplyJobs/components/Forms/YourResume/helpers/getDefaultResume.js';
import { MAX_NUMBER_OF_CV, IS_RESUME_ATTACHMENT, HTTP_CODE_SUCCESS } from '../ApplyJobs/constants.js';
import ResumeItemSkeleton from './ResumeItem/ResumeItem.skeleton.js';
import PopupCVReplace from '../PopupCVReplace/index.js';
import { validateAiResume } from '../services/ai-review/index.js';
import { DEFAULT_SUCCESS_CODE } from '../services/resumes/const.js';
import { buyCompetitiveAnalysis } from './services.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import LoadingIcon from '../Images/LoadingIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/ThreeDotIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/MiscGroupIcons/Link.js';
import '../icons/MiscGroupIcons/History.js';
import '../icons/MiscGroupIcons/Favorite.js';
import '../icons/MiscGroupIcons/UnFavorite.js';
import '../icons/MiscGroupIcons/ProductDocuments.js';
import '../icons/MiscGroupIcons/Star.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import '../Images/AiIcon/index.js';
import '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import '../Images/TwinkleLinearGradientIcon/index.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import PricingInfo from './PricingInfo/index.js';
import ButtonAI from '../ButtonAI/index.js';

var AIReviewCV = function (props) {
    var accessToken = props.accessToken, langCode = props.langCode, baseMsUrl = props.baseMsUrl, baseUrl = props.baseUrl, job = props.job, isTrial = props.isTrial, onClickPay = props.onClickPay, resumeOption = props.resumeOption, numsOfTrial = props.numsOfTrial, _a = props.isNewUI, isNewUI = _a === void 0 ? false : _a;
    var _b = props.showState, isShow = _b[0], setIsShow = _b[1];
    var _c = useState(false), isDisplayNone = _c[0], setIsDisplayNone = _c[1];
    var _d = useState(null), resumeInfos = _d[0], setResumeInfos = _d[1];
    var _e = useState(-1), selectResume = _e[0], setSelectResume = _e[1];
    var _f = useState(true), isLoadingResumes = _f[0], setIsLoadingResumes = _f[1];
    var _g = useState(0), profileStrength = _g[0], setProfileStrength = _g[1];
    var _h = useState(-1), replacingResumeId = _h[0], setReplacingId = _h[1];
    var _j = useState(true), isLockedPrimaryBtn = _j[0], setIsLockedPrimaryBtn = _j[1];
    var _k = useState(-1), resumeIdAIParseError = _k[0], setResumeIdAIParseError = _k[1];
    var _l = useState(-1), justUploadResumeId = _l[0], setJustUploadResumeId = _l[1];
    var dropFileComponentRef = useRef(null);
    var popupCVReplaceRef = useRef(null);
    var tracking = useHog().tracking;
    var t = useCallback(function (text) {
        var _a;
        if (langCode === ELanguage.VI) {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [langCode]);
    var onPay = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var cvType, filteredCV, response;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    cvType = 'online';
                    setIsLockedPrimaryBtn(true);
                    filteredCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.id === selectResume; });
                    if (filteredCV && (filteredCV === null || filteredCV === void 0 ? void 0 : filteredCV.length) > 0) {
                        cvType = filteredCV[0].isAttach === IS_RESUME_ATTACHMENT ? 'attach_before' : 'online';
                    }
                    if (justUploadResumeId !== -1) {
                        cvType = 'attach_new';
                    }
                    // for mobile JD source
                    onClickPay && onClickPay(cvType, isTrial);
                    tracking({
                        eventName: 'js_cv_review:finish_select_cv',
                        properties: {
                            cvType: cvType,
                            freeTrial: isTrial
                        }
                    }, {
                        transport: 'sendBeacon'
                    });
                    return [4 /*yield*/, buyCompetitiveAnalysis({
                            jobId: (_a = job === null || job === void 0 ? void 0 : job.jobId) !== null && _a !== void 0 ? _a : 0,
                            productId: 1,
                            quantity: 1,
                            resumeId: selectResume,
                            accessToken: accessToken,
                            msBaseUrl: baseMsUrl,
                            langCode: langCode
                        })];
                case 1:
                    response = _e.sent();
                    if ((response === null || response === void 0 ? void 0 : response.code) === DEFAULT_SUCCESS_CODE &&
                        ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.redirectUrl) &&
                        ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.redirectUrl) !== '') {
                        window.location.assign((_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.redirectUrl);
                    }
                    setIsLockedPrimaryBtn(false);
                    return [2 /*return*/];
            }
        });
    }); }, [selectResume, resumeInfos, justUploadResumeId, job === null || job === void 0 ? void 0 : job.jobId]);
    var validateResume = useCallback(function (resumeId) { return __awaiter(void 0, void 0, void 0, function () {
        var filteredCV, response;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    filteredCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.id === resumeId; });
                    if (filteredCV && (filteredCV === null || filteredCV === void 0 ? void 0 : filteredCV.length) > 0 && filteredCV[0].isAttach === 0) {
                        // Don't need to validate online profile
                        setResumeIdAIParseError(-1);
                        setIsLockedPrimaryBtn(false);
                        return [2 /*return*/];
                    }
                    // Attach CV
                    setIsLockedPrimaryBtn(true);
                    return [4 /*yield*/, validateAiResume({
                            accessToken: accessToken,
                            msBaseUrl: baseMsUrl,
                            langCode: langCode,
                            resumeId: resumeId !== null && resumeId !== void 0 ? resumeId : -1
                        })];
                case 1:
                    response = _d.sent();
                    if (((_a = response === null || response === void 0 ? void 0 : response.meta) === null || _a === void 0 ? void 0 : _a.status) === 400 ||
                        (((_b = response === null || response === void 0 ? void 0 : response.meta) === null || _b === void 0 ? void 0 : _b.code) && ((_c = response === null || response === void 0 ? void 0 : response.meta) === null || _c === void 0 ? void 0 : _c.code) !== DEFAULT_SUCCESS_CODE) ||
                        !response) {
                        // Show error
                        setResumeIdAIParseError(resumeId);
                        return [2 /*return*/];
                    }
                    setIsLockedPrimaryBtn(false);
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken, baseMsUrl, langCode, resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes]);
    var handleGetResume = useCallback(function (isDidMount) { return __awaiter(void 0, void 0, void 0, function () {
        var resumeInfo, resumeData, defaultResumeData;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoadingResumes(true);
                    return [4 /*yield*/, getResume({
                            accessToken: accessToken,
                            baseMsUrl: baseMsUrl,
                            langCode: langCode
                        })];
                case 1:
                    resumeInfo = _c.sent();
                    if (!resumeInfo || resumeInfo.error) {
                        setIsLockedPrimaryBtn(true);
                        return [2 /*return*/];
                    }
                    resumeData = getDefaultResume(resumeInfo.data);
                    defaultResumeData = (resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.defaultResumeId)
                        ? resumeInfo.data.attributes.find(function (item) { return item.id === (resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.defaultResumeId); })
                        : null;
                    if (defaultResumeData) {
                        resumeData = defaultResumeData;
                    }
                    if (isDidMount && (resumeData === null || resumeData === void 0 ? void 0 : resumeData.isAttach) === 1) {
                        validateResume((_a = resumeData === null || resumeData === void 0 ? void 0 : resumeData.id) !== null && _a !== void 0 ? _a : -1);
                    }
                    setResumeInfos(resumeInfo.data);
                    // Set default select Resume
                    setSelectResume((_b = resumeData === null || resumeData === void 0 ? void 0 : resumeData.id) !== null && _b !== void 0 ? _b : -1);
                    setIsLoadingResumes(false);
                    // Unlock primary btn when resume is online profile
                    if ((resumeData === null || resumeData === void 0 ? void 0 : resumeData.isAttach) === 0) {
                        setIsLockedPrimaryBtn(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accessToken, selectResume]);
    var handleGetProfileLevel = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var profileLevel;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getProfileLevel({
                        accessToken: accessToken,
                        langCode: langCode,
                        baseMsUrl: baseMsUrl
                    })];
                case 1:
                    profileLevel = _c.sent();
                    if ((_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.profileStrength) {
                        setProfileStrength((_b = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _b === void 0 ? void 0 : _b.profileStrength);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [accessToken]);
    var onUploadDone = useCallback(function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    (_a = dropFileComponentRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                    if ((response === null || response === void 0 ? void 0 : response.code) !== HTTP_CODE_SUCCESS) {
                        return [2 /*return*/];
                    }
                    if (!((response === null || response === void 0 ? void 0 : response.code) === HTTP_CODE_SUCCESS)) return [3 /*break*/, 2];
                    setResumeIdAIParseError(-1);
                    return [4 /*yield*/, handleGetResume()];
                case 1:
                    _h.sent();
                    setIsLockedPrimaryBtn(false);
                    setSelectResume((_c = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : -1);
                    setJustUploadResumeId((_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : -1);
                    // DO validate again
                    validateResume((_g = (_f = response === null || response === void 0 ? void 0 : response.data) === null || _f === void 0 ? void 0 : _f.id) !== null && _g !== void 0 ? _g : -1);
                    setReplacingId(-1);
                    _h.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [handleGetResume]);
    var onUploadError = useCallback(function (response) {
        if (!(response === null || response === void 0 ? void 0 : response.error)) {
            return;
        }
        setReplacingId(-1);
    }, []);
    var handleFileUpload = useCallback(function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var attachedCVs, isMaxCV, data;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    attachedCVs = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (cv) { return cv.isAttach; });
                    isMaxCV = attachedCVs && (attachedCVs === null || attachedCVs === void 0 ? void 0 : attachedCVs.length) >= MAX_NUMBER_OF_CV;
                    setIsLockedPrimaryBtn(true);
                    if (!(isMaxCV && popupCVReplaceRef.current)) return [3 /*break*/, 2];
                    // Open replace popup
                    setIsDisplayNone(true);
                    return [4 /*yield*/, popupCVReplaceRef.current.open()];
                case 1:
                    data = (_e.sent()).data;
                    setIsDisplayNone(false);
                    if (!data.resumeId) {
                        // Allow popup to trigger again if user drop the same file after cancel replacement request
                        (_a = dropFileComponentRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                        return [2 /*return*/];
                    }
                    setReplacingId((_b = data === null || data === void 0 ? void 0 : data.resumeId) !== null && _b !== void 0 ? _b : -1);
                    // Set state loading resume
                    (_c = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _c === void 0 ? void 0 : _c.doUploadFile(file, data === null || data === void 0 ? void 0 : data.resumeId);
                    return [3 /*break*/, 3];
                case 2:
                    setIsLoadingResumes(true);
                    // Set state loading resume
                    (_d = dropFileComponentRef === null || dropFileComponentRef === void 0 ? void 0 : dropFileComponentRef.current) === null || _d === void 0 ? void 0 : _d.doUploadFile(file);
                    _e.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes]);
    var onSelectResume = function (values) {
        setSelectResume(values.resumeId);
        validateResume(values.resumeId);
        setResumeIdAIParseError(-1);
    };
    useEffect(function () {
        if (!isShow) {
            return;
        }
        handleGetResume(true);
        handleGetProfileLevel();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken, isShow]);
    var primaryButtonText = function () {
        if (isLockedPrimaryBtn && resumeIdAIParseError === -1 && selectResume !== -1) {
            return t("Scanning file's content");
        }
        return t(isTrial ? 'View result' : 'Checkout to see result');
    };
    var renderRightSide = function () {
        var _a;
        return (React__default.createElement(CVSelectWrapper, null,
            React__default.createElement(Typography, { name: 'label', size: 'medium' }, t('Select an available profile on VietnamWorks.')),
            React__default.createElement(ResumeList, null, isLoadingResumes ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(ResumeItemSkeleton, null),
                React__default.createElement(ResumeItemSkeleton, null),
                React__default.createElement(ResumeItemSkeleton, null),
                React__default.createElement(ResumeItemSkeleton, null))) : ((_a = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes) === null || _a === void 0 ? void 0 : _a.map(function (item, index) {
                var isAttachedResume = item.isAttach === IS_RESUME_ATTACHMENT;
                var radioId = "attach-resume-".concat(item.id);
                if (!isAttachedResume) {
                    radioId = 'profile-online';
                }
                if (item.id === replacingResumeId) {
                    return React__default.createElement(ResumeItemSkeleton, { key: "cv-".concat(index, "-replace-").concat(item.id) });
                }
                // Check if cv is deletable
                var filteredAttachCV = resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes.filter(function (item) { return item.isAttach === 1; });
                var isDeletable = filteredAttachCV.length > 1;
                return (React__default.createElement(ResumeItem, { key: "cv-".concat(index, "-").concat(item.id), isAttach: isAttachedResume, radioId: radioId, cvInfo: item, profileStrength: profileStrength, resumeId: selectResume, applyResumeId: resumeOption === null || resumeOption === void 0 ? void 0 : resumeOption.applyResumeId, onChange: onSelectResume, langCode: langCode, baseUrl: baseUrl, isJustUploaded: justUploadResumeId === item.id, isAIParseError: resumeIdAIParseError === item.id, msBaseUrl: baseMsUrl, accessToken: accessToken, isDeletable: isDeletable, setIsLoadingResumes: setIsLoadingResumes, handleGetResume: handleGetResume }));
            }))),
            React__default.createElement(DragDropResumeUpload, { lang: langCode, accessToken: accessToken, ref: dropFileComponentRef, baseUrl: baseMsUrl, isCheckSpam: true, onUpload: handleFileUpload, isLoading: true, onUploadDone: onUploadDone, onUploadError: onUploadError, contentOptions: {
                    placeholder: '',
                    msg: '',
                    customMsg: t('Uploaded attachment will be added to your VietnamWorks account')
                } }),
            !isLoadingResumes && selectResume === -1 ? (React__default.createElement(Typography, { name: 'body', size: 'small', style: { marginTop: 8, color: colors.error[40] } }, t('Please upload your CV to see the evaluation.'))) : null));
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(PopupCVReplace, { ref: popupCVReplaceRef, langCode: langCode, maxNumberOfCV: MAX_NUMBER_OF_CV, cvList: (resumeInfos === null || resumeInfos === void 0 ? void 0 : resumeInfos.attributes) || [] }),
        React__default.createElement(Popup, { isShow: isShow, lang: langCode, option: {
                isShowSecondaryButton: false
            }, styleOption: {
                size: isNewUI ? 'lg' : 'sm',
                headerBg: 'linear-gradient(269deg, #B900F6 0.91%, #DC1EAF 23.38%, #FF6200 45.85%, #FDB92E 92.62%)',
                headerTextColor: '#fff',
                isHaveBorder: false,
                closeIconColor: '#fff',
                isDisplayNone: isDisplayNone
            }, custom: {
                footer: (React__default.createElement(CTAWrapper, null,
                    React__default.createElement(ButtonAI, { style: { width: isNewUI ? undefined : '100%' }, onClick: function () {
                            if (isLockedPrimaryBtn) {
                                return;
                            }
                            onPay();
                        } },
                        isLockedPrimaryBtn && resumeIdAIParseError === -1 && selectResume !== -1 ? (React__default.createElement(LoadingIcon, { bgColor: '#fff' })) : null,
                        ' ',
                        primaryButtonText())))
            }, text: {
                header: t('Select your CV to analyse')
            }, onClickOutside: function () { return setIsShow(false); }, onClose: function () { return setIsShow(false); } },
            React__default.createElement(AIReviewCVWrapper, null, isNewUI ? (React__default.createElement(AIReviewCVContainer, null,
                React__default.createElement(LeftSection, null,
                    React__default.createElement(PricingInfo, { job: job, t: t, numsOfTrial: numsOfTrial })),
                React__default.createElement(RightSection, null, renderRightSide()))) : (renderRightSide())))));
};

export { AIReviewCV as default };
//# sourceMappingURL=index.js.map
